import React, { useEffect, useState } from "react";
import "./comentarios.css";
import { detalle_blog } from "../../../assets/data/detalle_blog_header";
import { useAxios } from "../../../hooks/useAxios";
import { useCounter } from "../../../hooks/useCounter";
import { useComments } from "./useComments";
import { useForm } from "../../../hooks/useForm";
import ComentariosForm from "./ComentariosForm";
import { useTranslation } from "react-i18next";
import axios from "axios";

const Comentarios = ({ comentarios, friendlyTag, guid, titulo }) => {
  const [t, i18n] = useTranslation("home");
  const [totale, setTotale] = useState(3);
  const { counter, increment, decrement, defaultValue } = useCounter(0);
  const { comments, isLoading, error } = useComments({
    counter,
    comentarios,
    friendlyTag,
    totale,
  });

  const fechData = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/comments/byfriendly/${friendlyTag}?offset=0&limit=1000`
      );
      const data = response.data;
      return data;
    } catch (error) {
      console.error(error);
    }
  };

  const [totalElementos, setTotalElementos] = useState([]);
  const [paginaActual, setPaginaActual] = useState(1);
  const [paginasVisibles, setPaginasVisibles] = useState([]);
  let totalPaginas;
  if (totalElementos && totalElementos.length) {
    totalPaginas = Math.ceil(totalElementos.length / 2);
  } else {
    totalPaginas = 0;
  }

  useEffect(() => {
    const elementos = async () => {
      try {
        const data = await fechData();
        setTotalElementos(data);
      } catch (error) {
        console.error(error);
      }
    };
    elementos();
  }, []);

  useEffect(() => {
    const generarPaginasVisibles = () => {
      let paginaInicial, paginaFinal;

      // Caso 1: Menos de 5 páginas en total
      if (totalPaginas <= 5) {
        paginaInicial = 1;
        paginaFinal = totalPaginas;
      } else {
        // Caso 2: Más de 5 páginas en total
        if (paginaActual < 5) {
          // Estamos en las primeras 5 páginas
          paginaInicial = 1;
          paginaFinal = 5;
        } else if (paginaActual + 4 >= totalPaginas) {
          // Estamos en las últimas 5 páginas
          paginaInicial = totalPaginas - 4;
          paginaFinal = totalPaginas;
        } else {
          // Estamos en el medio de las páginas
          paginaInicial = paginaActual - 2;
          paginaFinal = paginaActual + 2;
        }
      }

      // Generar la lista de páginas visibles
      const paginas = [];
      for (let i = paginaInicial; i <= paginaFinal; i++) {
        paginas.push(i);
      }

      setPaginasVisibles(paginas);
    };

    generarPaginasVisibles();
  }, [paginaActual, totalPaginas]);

  const nextPage = () => {
    setPaginaActual(
      paginaActual === totalPaginas ? totalPaginas : paginaActual + 1
    );
  };

  const prevPage = () => {
    setPaginaActual(paginaActual === 1 ? 1 : paginaActual - 1);
  };

  const textcoment = () => {
    try {
      
      if (totalElementos.length > 0) {
        return(
          <div className="div_com_total">
          <p className="com_total">{totalElementos.length} comentarios</p>
          </div>
        );
      }
      else {
        return
      }
    } catch (e) {
      return
    }

  };

  const handleTotal = (value) => {
    setTotale(value);
  };

  const formatDate = (date) => {
    const options = { day: "numeric", month: "long", year: "numeric" };

    // return new Date(date).toLocaleDateString(undefined, options);
    return new Date(date).toLocaleDateString(i18n.language, options);
  };

  return (
    <div className="DB_comentarios">
      <ComentariosForm guid={guid} friendly={titulo} />
      {
        textcoment()
      }
      <div className="coment_show">
        {counter > 0 ? (
          <img
            className="coment_show_arrowL"
            onClick={() => {
              handleTotal(3);
              decrement();
            }}
            src="/assets/imgs/detalle_blog/arrow.png"
          />
        ) : (
          <div></div>
        )}
        {comments.map((comentario, i) => (
          <div
            key={comentario.nombre + " " + comentario.fecha}
            className="coment_show_card"
            id={"card_" + i}
          >
            <div className="coment_show_cardTitle">
              <br></br>
              <h5>
                {comentario.nombre + ", " + comentario.procedencia}
                <br />
                <br />
                {formatDate(comentario.fecha)}
                <br />
                <br />
              </h5>
            </div>
            <div className="coment_show_cardContent">
              <p dangerouslySetInnerHTML={{ __html: (comentario.comentario) }} ></p>
            </div>
          </div>
        ))}
        {counter > 0 && comments === null ? (
          <div></div>
        ) : (
          <img
            className="coment_show_arrowR"
            onClick={() => {
              handleTotal(3);
              increment();
            }}
            src="/assets/imgs/detalle_blog/arrow.png"
          />
        )}
        
        {/* Paginacion en movil */}
        <div className="coment_arrows_movil">
          {/* Boton para ir hacia atras */}
          <img
            className="coment_show_arrowL_movil"
            onClick={() => {
              handleTotal(2);
              decrement();
              prevPage();
            }}
            src="/assets/imgs/detalle_blog/arrow.png"
          />

          {/* Ellipisis para mostrar si es mas de las 5 primeras */}
          {paginaActual >= 5 && <a>...</a>}

          {/* Paginas visibles */}
          {paginasVisibles.map((page, i) => (
            <a
              key={page}
              className={`${page === paginaActual ? "active" : ""}`}
              onClick={() => {
                handleTotal(2);
                defaultValue(page - 1);
                setPaginaActual(page);
              }}
            >
              {page}
            </a>
          ))}
          {/* Ellipisis para mostrar si no es las 5 ultimas */}
          {paginaActual < totalPaginas - 4 && <a>...</a>}

          {/* Boton para ir hacia adelante */}
          <img
            className="coment_show_arrowR_movil"
            onClick={() => {
              handleTotal(2);
              increment();
              nextPage();
            }}
            src="/assets/imgs/detalle_blog/arrow.png"
          />
        </div>
      </div>
      
    </div>
  );
};

export default Comentarios;
